import script from "./GrouperHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrouperHeader.vue?vue&type=script&setup=true&lang=ts"

import "./GrouperHeader.vue?vue&type=style&index=0&id=c95730e0&lang=scss"

const __exports__ = script;

export default __exports__
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QToolbarTitle,QItem});
